function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2808.203 -2844.795)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2844.663,2913.908l1.82,5.461a4.147,4.147,0,0,0,3.936,2.837h6l-1.037-8.3Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2893.758,2922.206h6a4.147,4.147,0,0,0,3.936-2.837l1.82-5.461h-10.718Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2865.3,2926.87a4.148,4.148,0,0,0,4.116,3.634h11.345a4.148,4.148,0,0,0,4.117-3.634l5.769-46.153H2859.53Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2874.662,2844.795a66.459,66.459,0,1,0,66.459,66.459A66.46,66.46,0,0,0,2874.662,2844.795Zm35.509,80.035a8.3,8.3,0,0,1-7.872,5.674h-9.578l-.129,1.029a8.3,8.3,0,0,1-8.234,7.269h-5.121v8.3h8.3v8.3h-24.894v-8.3h8.3v-8.3h-5.122a8.3,8.3,0,0,1-8.233-7.269l-.129-1.029h-9.578a8.3,8.3,0,0,1-7.872-5.674l-6.406-19.22h20.744l-4.149-33.191h49.788l-4.149,33.191h20.744Z",
  fill: "#fff"
}));

var SvgBigCup = function SvgBigCup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.918,
    height: 132.918,
    viewBox: "0 0 132.918 132.918",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigCup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/big-cup.61f9bdaf.svg";
export { ForwardRef as ReactComponent };